<template>
  <!-- dashboard-area start -->
  <div class="dashboard-area pt-30">
    <div class="container cardspadding">
      <div class="col-12 cardspadding">
        <div class="row justify-content-center ">
          <div class="col-12 cardspadding">
            <div class="pannel-wrapper white-bg mb-60 ">
              <div class="heading-border">
                <img
                  src="https://www.lefisc.com.br/monitoramentoncm/img/aliquotas.png"
                  class="img-fluid"
                  alt
                />
              </div>

              <div class="col-12">
                <transition name="exibir">
                  <ncm :dadosNCM="dadosNCM" v-if="!loading && !mensagemErro" />
                  <h4
                    class="erro mt-5 mb-5 text-center"
                    v-if="!loading && mensagemErro"
                  >{{ mensagemErro }}</h4>
                </transition>
                <!-- LOADING -->
                <div class="text-center" v-if="loading">
                  <div class="spinner-border text-primary mt-5 mb-5 text-center" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </div>

              <div>
                <div class="heading-border">
                  <img
                    src="https://www.lefisc.com.br/monitoramentoncm/img/historico.png"
                    class="img-fluid"
                    alt
                  />
                </div>
                <transition
                  name="exibir"
                  v-if="!loadingAlteracoes && mensagemErro != 'NCM não encontrada!'"
                >
                  <alteracoes :alteracoesNCM="alteracoesNCM" :mensagem="mensagemAlteracoes" />
                  <!--<card :alteracoes="alteracoes"/>-->
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- dashboard-area end -->
</template>

<script>
import serviceHistorico from "../services/ServiceHistorico";
import ncm from "../components/historico/ncm";
import alteracoes from "../components/historico/alteracoes";
import card from "../shared/card";

export default {
  components: {
    ncm,
    alteracoes,
    card
  },

  data() {
    return {
      dadosNCM: {},
      loading: true,
      loadingAlteracoes: false,
      numNCM: this.$route.params.ncm,
      mensagemErro: "",
      alteracoesNCM: [],
      mensagemAlteracoes: ""
    };
  },
  async created() {
    await serviceHistorico.getDadosNCM(this.numNCM).then(
      res => {
        if (res == "NCM não encontrada!") this.mensagemErro = res;
        this.dadosNCM = res;
        this.loading = false;
      },
      err => {
        console.error("nao foi possivel obter dados do servidor");
      }
    );

    //alteracoes
    if (this.numNCM) {
      await serviceHistorico.getAlteracoesDaNCM(this.numNCM).then(
        res => {
          if (res != -1) {
            this.alteracoesNCM = res;

            this.loadingAlteracoes = false;
          } else {
            this.mensagemAlteracoes =
              "Ainda não temos alterações para a NCM escolhida";
          }
        },
        erro => {
          console.error(erro);
        }
      );
    } else {
      await serviceHistorico.getHistoricoNCMs().then(
        res => {
          if (res != -1) {
            this.alteracoesNCM = res;
            this.loadingAlteracoes = false;
          } else {
            console.error("Não há alterações");
          }
        },
        erro => {
          console.error(erro);
        }
      );
    }
  }
};
</script>

<style scoped>
.w-50 {
  width: 50%;
}
.hr {
  border-bottom: 1px solid #eceff8;
  border-top: 0 none;
  margin: 10px 0;
  padding: 0;
}

.spinner-border {
  height: 100px;
  width: 100px;
  font-size: 30px;
}

.exibir-enter,
.exibir-leave-to {
  opacity: 0;
}

.exibir-enter-to,
.exibir-leave {
  opacity: 1;
}

.exibir-leave-active,
.exibir-enter-active {
  transition: all 0.5s;
}

.erro {
  font-size: 25px;
}

.cardspadding {
  padding:0px;
}
</style>